import { authHeader, handleResponse } from '../helpers'

export const typeService = {
  getTypes,
  getType,
  createType,
  updateType,
  deleteType
}

function getTypes() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(process.env.VUE_APP_API_URL + '/type', requestOptions)
    .then(handleResponse)
    .then((response) => {
      var types = response.types
      return types
    })
}

function getType(typeId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(process.env.VUE_APP_API_URL + '/type/' + typeId, requestOptions)
    .then(handleResponse)
    .then((response) => {
      var type = response
      return type
    })
}

function createType(typeData) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: typeData
  }
  return fetch(process.env.VUE_APP_API_URL + '/type', requestOptions)
    .then(handleResponse)
    .then((response) => {
      var type = response
      return type
    })
}

function updateType(typeId, typeData) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: typeData
  }
  return fetch(process.env.VUE_APP_API_URL + '/type/' + typeId, requestOptions)
    .then(handleResponse)
    .then((response) => {
      var type = response
      return type
    })
}

function deleteType(typeId) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }
  return fetch(process.env.VUE_APP_API_URL + '/type/' + typeId, requestOptions)
    .then(handleResponse)
    .then((response) => {
      var type = response
      return type
    })
}
